import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, Button, Stack } from '@mui/material';
import { useMemo, useState } from 'react';
import { ActionConfirmation } from '../../common/ActionConfirmation';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const ActionConfirmationWidget = () => {
    const [open, setOpen] = useState(false);
    const component = useMemo(() => (_jsxs(Stack, { gap: 1, children: [_jsx(Alert, { severity: "info", children: "This widget is a dialog, triggered by a user's action \u2014 use the button to simulate an action" }), _jsx("div", { children: _jsx(Button, { variant: "contained", onClick: () => setOpen(true), children: "Open widget" }) }), _jsx(ActionConfirmation, { open: open, setOpen: setOpen, header: 'Header for ActionConfirmation', message: 'Message for the ActionConfirmation widget that is provided to describe the action to the user', onConfirmation: () => {
                    // do your actual action here
                } })] })), [open]);
    return {
        name: 'ActionConfirmation',
        category: 'common',
        component,
    };
};
